import { E2EPage, newE2EPage } from '@stencil/core/testing';
import { Input } from '../input';

export const getPage = async (
  {
    disabled,
    error,
    errorMessage,
    helperText,
    hideIconEnd,
    hideIconStart,
    iconEnd,
    iconStart,
    max,
    maxlength,
    min,
    minlength,
    minlengthMessage,
    name,
    pattern,
    patternMessage,
    placeholder,
    readonly,
    required,
    requiredMessage,
    tooltip,
    type,
    value,
    width,
  }: Partial<Input> = {},
  children = ''
): Promise<E2EPage> => {
  const page = await newE2EPage();

  await page.setContent(`
      <abds-input
        ${disabled ? 'disabled' : ''}
        ${error ? 'error' : ''}
        ${errorMessage ? `error-message="${errorMessage}"` : ''}
        ${helperText ? `helper-text="${helperText}"` : ''}
        ${hideIconEnd ? 'hide-icon-end' : ''}
        ${hideIconStart ? 'hide-icon-start' : ''}
        ${iconEnd ? `icon-end="${iconEnd}"` : ''}
        ${iconStart ? `icon-start="${iconStart}"` : ''}
        ${max ? `max="${max}"` : ''}
        ${maxlength ? `maxlength="${maxlength}"` : ''}
        ${min ? `min="${min}"` : ''}
        ${minlength ? `minlength="${minlength}"` : ''}
        ${minlengthMessage ? `minlength-message="${minlengthMessage}"` : ''}
        ${name ? `name="${name}"` : ''}
        ${pattern ? `pattern="${pattern}"` : ''}
        ${patternMessage ? `pattern-message="${patternMessage}"` : ''}
        ${placeholder ? `placeholder="${placeholder}"` : ''}
        ${readonly ? 'readonly' : ''}
        ${required ? 'required' : ''}
        ${requiredMessage ? `required-message="${requiredMessage}"` : ''}
        ${tooltip ? `tooltip="${tooltip}"` : ''}
        ${type ? `type="${type}"` : ''}
        ${value ? `value="${value}"` : ''}
        ${width ? `width="${width}"` : ''}
      >${children}</abds-input>
    `);

  return await page;
};
